<template>
  <div class="trade-data">
    <van-row>
       <van-col :span="24" style="margin: 8px 0">
        <p
          class="trade-date-price"
          :class="tradetype == 0 ? 'data-up' : 'data-down'"
        >
          {{ parseFloat(tick.close).toFixed(8) }}
        </p>
        <span class="trade-date-price-desc"
          >&#8776; {{ parseFloat(tick.close).toFixed(2) }}</span
        >
      </van-col>
    </van-row>
    <van-row class="trade-data-head">
      <van-col :span="12">
        <span class="table-head">{{ $t("trade.price") }}</span>
      </van-col>
      <van-col :span="12" class="txt-right">
        <span class="table-head">{{ $t("trade.num") }}</span>
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24" v-for="item in sellindex" :key="'sell' + item">
        <div class="trade-date-item" v-if="selldata[item] && selldata[item].price && selldata[item].amount">
          <div class="trade-date-item-bg" :style="'width:' + 0 * 20 + '%;'" />
          <div class="trade-date-item-price data-down">
            {{ parseFloat(selldata[item].price).toFixed(6) }}
          </div>
          <div class="trade-date-item-num">
            {{ parseFloat(selldata[item].amount).toFixed(6) }}
          </div>
        </div>
        <div v-else style="height: 37px; text-align: center">
          <van-loading />
        </div>
      </van-col>
      <van-col :span="24" v-for="item in buyindex" :key="'buy' + item">
        <div class="trade-date-item" v-if="buydata[item] && buydata[item].price && buydata[item].amount">
          <div class="trade-date-item-bg1" :style="'width:' + 0 * 20 + '%;'" />
          <div class="trade-date-item-price data-up">
            {{ parseFloat(buydata[item].price).toFixed(6) }}
          </div>
          <div class="trade-date-item-num">
            {{ parseFloat(buydata[item].amount).toFixed(6) }}
          </div>
        </div>
        <div v-else style="height: 37px; text-align: center">
          <van-loading />
        </div>
      </van-col>
    </van-row>
    <div style="position: absolute; left: 10px; bottom: 0px;display: none;">
      <svg-icon
        icon-class="pan1"
        class="btn-pan border-blue"
        @click="toall()"
      />
      <svg-icon icon-class="pan2" class="btn-pan" @click="tobuy()" />
      <svg-icon icon-class="pan3" class="btn-pan" @click="tosell()" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TradeData",
  props: ["symbol", "tradetype"],
  computed: {
    safeSymbol() {
      return this.symbol || "";
    },
    safeTradeType() {
      return this.tradetype || 0;
    },
  },
  watch: {
    symbol() {},
    tradetype() {},
  },
  data() {
    return {
      timer: null,
      timer1: null,
      tick: {},
      buydata: [],
      selldata: [],
      buyindex: 5,
      sellindex: 5,
    };
  },
  mounted() {
    const that = this;
    this.getLstData();
    this.getDayData();
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getLstData();
      }, 2000);
    });
    this.$nextTick(() => {
      that.timer1 = setInterval(() => {
        that.getDayData();
      }, 5000);
    });
  },
  methods: {
    toall() {
      this.buyindex = 5;
      this.sellindex = 5;
    },
    tobuy() {
      this.buyindex = 9;
      this.sellindex = 0;
    },
    tosell() {
      this.buyindex = 0;
      this.sellindex = 9;
    },
    getDayData() {
      if (this.safeSymbol != "") {
        fetch("/huobiapi/market/detail?symbol=" + this.safeSymbol)
          .then((res) => res.json())
          .then((data) => {
            if (data.status == "ok") {
              this.tick = data.tick;
              this.$emit("change-price", this.tick);
            }
          });
      }
    },
    async getLstData() {
      if (this.safeSymbol != "") {
        await this.$http({
          method: "post",
          url: "getHuoBiTradeFromRedis",
          data: {symbol: this.safeSymbol},
        }).then((res) => {
          this.selldata = res.data.sell
          this.buydata = res.data.buy
        });

        /*
        fetch(
          "/huobiapi/market/history/trade?size=100&symbol=" + this.safeSymbol
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.status == "ok") {
              for (let i = 0; i < data.data.length; i++) {
                const tmp = data.data[i].data[0];
                if (tmp.direction == "sell") {
                  this.selldata.unshift(tmp);
                }
                if (tmp.direction == "buy") {
                  this.buydata.unshift(tmp);
                }
                if (i >= 100) {
                  break;
                }
              }
            }
          });
          */
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.timer1) clearInterval(this.timer1);
  },
};
</script>

<style>
</style>
